var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRestaurantHighEnd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Tools-Kitchen-Serving-Dome--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Tools Kitchen Serving Dome Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23 17.38H1a1 1 0 0 0 0 2h1.06a1 1 0 0 1 0.83 0.44l0.45 0.66a2 2 0 0 0 1.66 0.9h14a2 2 0 0 0 1.66 -0.9l0.45 -0.66a1 1 0 0 1 0.83 -0.44H23a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 15.88h18a0.5 0.5 0 0 0 0.5 -0.5 9.51 9.51 0 0 0 -7.28 -9.24 0.26 0.26 0 0 1 -0.16 -0.14 0.28 0.28 0 0 1 0 -0.22 2.16 2.16 0 0 0 0.2 -0.91 2.25 2.25 0 1 0 -4.5 0 2.16 2.16 0 0 0 0.2 0.91 0.24 0.24 0 0 1 0 0.22 0.26 0.26 0 0 1 -0.16 0.13 9.51 9.51 0 0 0 -7.3 9.25 0.5 0.5 0 0 0 0.5 0.5ZM6.46 10a7.81 7.81 0 0 1 4.43 -2.3 0.75 0.75 0 0 1 0.22 1.49A6.2 6.2 0 0 0 7.54 11a0.78 0.78 0 0 1 -0.54 0.23 0.74 0.74 0 0 1 -0.53 -0.23 0.75 0.75 0 0 1 -0.01 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRestaurantHighEnd);
export default ForwardRef;